import React, {useEffect, Fragment} from "react";
import PropTypes from "prop-types";
import PilotFaq from "../pilot-faq";
import { NUMBER } from "../../../constants/app-constants";
import styles from "./styles.css";
import { vhrEventNames, vhrEvents } from "../../../constants/car-service-history-constants";

const CarServiceHistoryFaqs = ({
    faqList,
    fetchFaqListConnect,
    isSsr
}) => {

    useEffect(() => {
        if (!isSsr && faqList.length === NUMBER.ZERO) fetchFaqListConnect({slug: "service-history"});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSsr]);

    return (
        <Fragment>
            {faqList && faqList.length > NUMBER.ZERO &&
                <Fragment>
                    <PilotFaq
                        heading="Frequently asked questions"
                        faqs={faqList}
                        attachSchema={true}
                        customEvent={true}
                        customEventValue={{...vhrEvents, eventAction: vhrEventNames.FAQ_CLICKED}}
                    />
                    <a styleName={"styles.allfaq"} href="/faq/" target="_blank">see all faqs</a>
                </Fragment>
            }
        </Fragment>
    );
};

CarServiceHistoryFaqs.propTypes = {
    history: PropTypes.object,
    faqList: PropTypes.array,
    fetchFaqListConnect: PropTypes.func,
    isSsr: PropTypes.bool
};

export default CarServiceHistoryFaqs;
